// extracted by mini-css-extract-plugin
export var actions = "ingredient-swap-modal-module--actions--9275b";
export var button = "ingredient-swap-modal-module--button--d922e";
export var error = "ingredient-swap-modal-module--error--3d4b4";
export var list = "ingredient-swap-modal-module--list--f8e2e";
export var loaderBox = "ingredient-swap-modal-module--loader-box--43f45";
export var modal = "ingredient-swap-modal-module--modal--7ecc9";
export var noContent = "ingredient-swap-modal-module--no-content--d5636";
export var proposal = "ingredient-swap-modal-module--proposal--b03db";
export var proposalMacro = "ingredient-swap-modal-module--proposal-macro--edd8a";
export var proposalName = "ingredient-swap-modal-module--proposal-name--a454a";
export var proposalReason = "ingredient-swap-modal-module--proposal-reason--c204e";
export var selected = "ingredient-swap-modal-module--selected--ed7dc";